export const getFormsAssistantFormName = () => 'FormsAssistant';
